import R from "ramda";
import convertToGroupsList from "./convertToGroupsList";

export default data => {
  const {
    name,
    status = "pending",
    title = "",
    subTitle = "",
    description = "",
    steps = {}
  } = data;
  return {
    applyId: 0,
    name,
    status,
    title,
    subTitle,
    description,
    stepsList: R.reduce(
      (accSteps, curStep) => [...accSteps, curStep.fields.name],
      []
    )(steps),
    steps: R.reduce(
      (accSteps, curStep) => ({
        ...accSteps,
        [curStep.fields.name]: {
          name: curStep.fields.name,
          step: curStep.fields.step,
          status: curStep.fields.status,
          label: curStep.fields.label,
          headline: curStep.fields.headline,
          description: curStep.fields.description,
          cardsList: R.reduce(
            (accCards, curCard) => [...accCards, curCard.fields.name],
            []
          )(curStep.fields.cards)
        }
      }),
      {}
    )(steps),
    cards: R.reduce(
      (accSteps, curStep) => ({
        ...accSteps,
        ...R.reduce(
          (accCards, curCard) => ({
            ...accCards,
            [curCard.fields.name]: {
              name: curCard.fields.name,
              status: curCard.fields.status,
              minutes: curCard.fields.minutes,
              icon: curCard.fields.icon,
              label: curCard.fields.label,
              title: curCard.fields.title,
              description: curCard.fields.description,
              extra: curCard.fields.extra || {},
              groupsList: R.compose(
                convertToGroupsList,
                R.reduce(
                  (accGroups, curGroup) => [
                    ...accGroups,
                    {
                      ...curGroup.fields,
                      icon: curGroup.fields.icon || {}
                    }
                  ],
                  []
                )
              )(curCard.fields.groups)
            }
          }),
          {}
        )(curStep.fields.cards)
      }),
      {}
    )(steps),
    groups: R.reduce(
      (accSteps, curStep) => ({
        ...accSteps,
        ...R.reduce(
          (accCards, curCard) => ({
            ...accCards,
            ...R.reduce(
              (accGroups, curGroup) => ({
                ...accGroups,
                [curGroup.fields.name]: {
                  name: curGroup.fields.name,
                  type: curGroup.fields.type,
                  status: curGroup.fields.status,
                  icon: curGroup.fields.icon || {},
                  title: curGroup.fields.title,
                  description: curGroup.fields.description,
                  extra: curGroup.fields.extra || {},
                  fieldsList: R.reduce(
                    (accFields, curField) => [
                      ...accFields,
                      curField.fields.name
                    ],
                    []
                  )(curGroup.fields.fields)
                }
              }),
              {}
            )(curCard.fields.groups)
          }),
          {}
        )(curStep.fields.cards)
      }),
      {}
    )(steps),
    fields: R.reduce(
      (accSteps, curStep) => ({
        ...accSteps,
        ...R.reduce(
          (accCards, curCard) => ({
            ...accCards,
            ...R.reduce(
              (accGroups, curGroup) => ({
                ...accGroups,
                ...R.reduce(
                  (accFields, curField) => ({
                    ...accFields,
                    [curField.fields.name]: {
                      name: curField.fields.name,
                      type: curField.fields.type,
                      grid: curField.fields.grid,
                      actions: curField.fields.actions || {},
                      rules: (curField.fields.rules || {}).rules || [],
                      value: curField.fields.value,
                      error: curField.fields.error || "",
                      optionGroupName: curField.fields.optionGroupName,
                      description: curField.fields.description,
                      label: curField.fields.label,
                      placeholder: curField.fields.placeholder,
                      extra: curField.fields.extra || {}
                    }
                  }),
                  {}
                )(curGroup.fields.fields)
              }),
              {}
            )(curCard.fields.groups)
          }),
          {}
        )(curStep.fields.cards)
      }),
      {}
    )(steps)
  };
};
